if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      connectedCallback() {
        this.cardImage = this.closest('.card-wrapper')?.querySelector('.card__media img.motion-reduce');
        if (!this.cardImage) return;

        this.originalSrc = this.cardImage.getAttribute('src');
        this.originalSrcset = this.cardImage.getAttribute('srcset');

        this.addEventListener('focusin', this.onSwatchEnter.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));

        // Only swap on hover for pointers that actually support hovering.
        // On touch devices, a mouseover-driven swap makes links need a
        // second tap to navigate (the first tap only simulates :hover).
        if (window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('mouseover', this.onSwatchEnter.bind(this));
          this.addEventListener('mouseleave', this.resetImage.bind(this));
        } else {
          // Touch devices don't have a hover step, so the first tap on a
          // swatch previews its image instead of following the link.
          // Tapping that same (already active) swatch again navigates.
          this.activeSwatch = null;
          this.addEventListener('click', this.onSwatchTap.bind(this));
        }
      }

      onSwatchTap(event) {
        const swatch = event.target.closest('.card__swatch');
        if (!swatch || !swatch.hasAttribute('data-swatch-image')) return;

        if (swatch === this.activeSwatch) return;

        event.preventDefault();
        this.activeSwatch?.classList.remove('card__swatch--active');
        this.activeSwatch = swatch;
        swatch.classList.add('card__swatch--active');
        this.onSwatchEnter(event);
      }

      onSwatchEnter(event) {
        const swatch = event.target.closest('.card__swatch');
        const image = swatch?.getAttribute('data-swatch-image');
        if (!image) return;

        this.cardImage.removeAttribute('srcset');
        this.cardImage.setAttribute('src', image);
      }

      onFocusOut(event) {
        if (this.contains(event.relatedTarget)) return;
        this.resetImage();
      }

      resetImage() {
        if (this.originalSrcset) {
          this.cardImage.setAttribute('srcset', this.originalSrcset);
        }
        this.cardImage.setAttribute('src', this.originalSrc);
        this.activeSwatch?.classList.remove('card__swatch--active');
        this.activeSwatch = null;
      }
    }
  );
}
